import {
  checkExperiment,
  ExperimentChecker,
  ribbonExperiments,
} from "@1js/acui-experiments";

export type ShadowRenderMenu =
  | boolean
  | undefined
  | (() => boolean | undefined);

export function shouldShadowRender(
  shadowRenderMenu: ShadowRenderMenu,
  context: ExperimentChecker,
  isMeasured: any
): boolean | undefined {
  return (
    getShadowRenderMenuValue(shadowRenderMenu) !== false &&
    (checkExperiment(context, ribbonExperiments.shadowRenderingIsEnabled) ||
      checkExperiment(context, ribbonExperiments.shadowRenderingIsEnabledFG)) &&
    isMeasured === false
  );
}

export function getShadowRenderMenuValue(
  shadowRenderMenu: ShadowRenderMenu
): boolean | undefined {
  return typeof shadowRenderMenu === "function"
    ? shadowRenderMenu()
    : shadowRenderMenu;
}
